import {
  computeDatePickerAnchorPosition,
  type DatePickerAnchorOptions,
  type DatePickerAnchorRect,
} from '../../DatePicker/anchorPositioning'

export type DatePickerAnchorPosition = Pick<DatePickerAnchorRect, 'top' | 'left' | 'width'>

export type DatePickerAnchorState = {
  triggerKey: string
  position: DatePickerAnchorPosition
}

export function createDatePickerPosition(
  element: HTMLElement,
  options?: DatePickerAnchorOptions,
): DatePickerAnchorPosition {
  const { top, left, width } = computeDatePickerAnchorPosition(element, null, options)
  return { top, left, width }
}

export const calculatePosition = createDatePickerPosition
